var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBizIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 44,
    viewBox: "0 0 43 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4925 0.735352C9.10663 1.13824 0 10.4955 0 21.9796C0 29.1609 3.5609 35.5105 9.01331 39.359V30.4378C7.35111 28.0361 6.37734 25.1216 6.37734 21.9796C6.37734 14.0181 12.6299 7.51683 20.4925 7.11852V0.735352Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8831 0.751709H22.3171L22.3171 10.6428L22.3171 43.2109C25.7902 43.0399 29.0442 42.0353 31.8831 40.3931L31.8831 35.8818V0.751709ZM33.7963 13.051H40.5518C41.8099 15.7656 42.512 18.7904 42.512 21.9792C42.512 29.029 39.0803 35.2772 33.7963 39.1446V13.051ZM20.4039 25.0829V43.2203C16.9376 43.084 13.6845 42.1176 10.8379 40.5144L10.8379 25.0829L20.4039 25.0829Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBizIcon1);
export default __webpack_public_path__ + "static/media/bizIcon1.2017e5db2910704cdce036ab9711f3b1.svg";
export { ForwardRef as ReactComponent };